import React, { useEffect, useState } from "react";
import { withRouter, Link, Route, useHistory, useLocation } from "react-router-dom";
import "./LeagueGroups.css"
import TeamsListing from "./Teams/TeamsListing";
import Tab from "../../../../../../Util/Tabs/Tab.js";
import { motion } from 'framer-motion';
import { pageTransitions, transitionDuration } from '../../../../../../Util/PageTransitions';
import { getUrlToPush, LEAGUE_STATUS } from "../../../../../../Util/helper";
import back from "../../../../../../assets/arrow-back.svg";
import dropdown from "../../../../../../assets/dropdown.svg";
import axiosApi from "../../../../../../core/interceptor/interceptor";
import { config, PERMISSIONS } from "../../../../../../config";
import WeeklyMatch from "./WeeklyMatchups/WeeklyMatch";
import ScheduleOverview from "./ScheduleOverview/ScheduleOverview";
import PlayOffBracket from "./PlayOffBracket/PlayOffBracket";
import { permissions } from "../../../../../../Store/reducers/PermissionsReducer";
import { useSelector } from "react-redux";

import Divisions from "./Divisions/Divisions";
import LeagueSettings from "./LeagueSettings/LeagueSettings";
import useSearchParam from "../../../../../../hooks/UrlSearchParam";
import TeamStandings from './TeamStandings/TeamStandings';

function LeagueGroups(props) {
  const permission = useSelector(permissions);
  const history = useHistory();
  const [messageDropEnable, setMessageDropEnable] = useState(false);
  const [hasPlayer, setHasPlayer] = useState(false);
  const [leagueInfo, setLeagueInfo] = useState({ name: '', status: '' });
  const [tabs, setTabs] = useState([])
  const [leagueId, setLeagueId] = useState(0);
  const leagueId_ = useSearchParam(props.location).get('leagueId');
  const search = useLocation().search;
  const season_id = new URLSearchParams(search).get('season_id');

  useEffect(() => {
    if (!leagueId_) {
      if (props.location.state && props.location.state.league_id) {
        setLeagueId(props.location.state.league_id)
      }
    } else {
      setLeagueId(leagueId_);
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (leagueId > 0) {
      Promise.all([
        getPlayer(),
        getLeagueDetail(),
      ]);
    }
    //eslint-disable-next-line
  }, [leagueId]);

  const getPlayer = () => {
    axiosApi.get(`${config.apiUrl}/teams/leagues/players/${leagueId}`)
      .then((response) => {
        if (response.data.data) {
          setHasPlayer(true);
        }

      })
  }

  const enableMesgDrop = () => {
    setMessageDropEnable(!messageDropEnable);
  }

  const getLeagueDetail = () => {
    let allTabs = [
      {
        name: 'Teams',
        url: '',
        search: `?leagueId=${leagueId}${(season_id) ? `&season_id=${season_id}` : ''}`
      },
      {
        name: 'Weekly Matchups',
        url: '/weekly-match',
        search: `?leagueId=${leagueId}${(season_id) ? `&season_id=${season_id}` : ''}`
      },
      {
        name: 'Schedule Overview',
        url: '/schedule-overview',
        search: `?leagueId=${leagueId}${(season_id) ? `&season_id=${season_id}` : ''}`
      },
      {
        name: 'Playoff Bracket',
        url: '/playoff-bracket',
        search: `?leagueId=${leagueId}${(season_id) ? `&season_id=${season_id}` : ''}`
      },
      {
        name: 'Divisions',
        url: '/division',
        search: `?leagueId=${leagueId}${(season_id) ? `&season_id=${season_id}` : ''}`
      },
      {
        name: 'Team Standings',
        url: '/standings',
        search: `?leagueId=${leagueId}${(season_id) ? `&season_id=${season_id}` : ''}`
      },
      {
        name: 'League Settings',
        url: '/league-settings',
        search: `?leagueId=${leagueId}${(season_id) ? `&season_id=${season_id}` : ''}`
      }
    ];
    axiosApi.get(`${config.apiUrl}/misc/league/season/info/${leagueId}`)
      .then((response) => {
        switch (LEAGUE_STATUS[response.data.data.status]) {
          case 'Sign-up':
            setTabs(allTabs.filter(x => !['Weekly Matchups', 'Schedule Overview', 'Playoff Bracket'].includes(x.name)));
            break;
          case 'Needs Schedule':
            setTabs(allTabs.filter(x => !['Playoff Bracket'].includes(x.name)));
            break;
          default:
            setTabs(allTabs);
            break;
        }
        setLeagueInfo(response.data.data);
      })
      .catch((err) => {
      })
      .finally(() => {
      });
  }

  return (
    <>
      <motion.div className='outer-wrapper' initial={pageTransitions.initial} animate={pageTransitions.in} exit={pageTransitions.out} transition={{ duration: transitionDuration }}>
        <div className={messageDropEnable ? 'overlay' : ''} onClick={() => setMessageDropEnable(false)}></div>
        {leagueInfo && tabs.length > 0 && <div className="content-wrapper users-wrapper">
          <div className="leaguesGroups-wrapper">
            <div className="groups-wrapper">
              <div className="heading-wrapper">
                <div className="header-blk header-blk-overview">
                  <button className="back-btn btn-primary" onClick={
                    () => {
                      if (props?.location?.state?.from === 'transactions') {
                        history.push(getUrlToPush('transactions'));
                      } else {
                        history.push({
                          pathname: `/admin/leagues/overview`,
                          search: `${(season_id) ? `?season_id=${season_id}` : ''}`,
                        })
                      }
                    }
                  }><img src={back} alt='back-icon' />Back to {props?.location?.state?.from === 'transactions' ? 'Transactions' : 'Overview'}</button>
                  {
                    hasPlayer && permission.includes(PERMISSIONS.MASS_EMAIL) &&
                    <div className="dropdown-blk">
                      <div className="dropdown-header" onClick={enableMesgDrop}>
                        <img src={dropdown} alt='dropdown' />
                        <span>Message League</span>
                      </div>
                      <ul className={`${messageDropEnable && 'active'} dropdown-menu`}>
                        {
                          permission.includes(PERMISSIONS.MASS_EMAIL) &&
                          <li>
                            <Link to={`/admin/send-email?leagueId=${leagueId}${season_id ? `&season_id=${season_id}` : ''}`}>Send Email</Link>
                          </li>
                        }
                        {/* {
                          permission.includes(PERMISSIONS.MASS_TEXT) &&
                          <li>
                            <Link to={`/admin/send-sms?leagueId=${leagueId}${season_id ? `&season_id=${season_id}` : ''}`}>Send Text</Link>
                          </li>
                        } */}
                      </ul>
                    </div>
                  }
                  
                </div>
                <h2 className="heading">{leagueInfo.name}</h2>
              </div>
            </div>
            {tabs && tabs.length > 0 && <Tab tabs={tabs} />}
            <Route path={`${props.match.path}`} exact>
              <TeamsListing leagueInfo={leagueInfo} />
            </Route>
            <Route path={`${props.match.path}/weekly-match`}>
              <WeeklyMatch />
            </Route>
            <Route path={`${props.match.path}/schedule-overview`}>
              <ScheduleOverview />
            </Route>
            <Route path={`${props.match.path}/playoff-bracket`}>
              <PlayOffBracket />
            </Route>
            <Route path={`${props.match.path}/division`}>
              <Divisions />
            </Route>
            <Route path={`${props.match.path}/league-settings`}>
              <LeagueSettings />
            </Route>
            <Route path={`${props.match.path}/standings`}>
              <TeamStandings />
            </Route>
          </div>
        </div>}
      </motion.div>
    </>
  );
}

export default withRouter(LeagueGroups);
